import { ButtonHTMLAttributes } from 'react'

import SVGIcon from '@/components/base/svg-icon'
import Typography from '@/components/base/typography'
import { useStore } from '@/contexts/store'

export type LoadMoreProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  fetching?: boolean
}

const BioLabel = ({ ...props }: LoadMoreProps) => {
  const { strings } = useStore()

  return (
    <span
      {...props}
      className="flex items-center gap-x-[1.6rem] bg-surface-accent-light p-[1.6rem]"
    >
      <SVGIcon
        symbol="eco-icon"
        className="h-[1.7rem] w-[1.7rem] fill-white-light"
      />
      <Typography variant="regular" className="text-white-light">
        {strings?.labels.bio_available}
      </Typography>
    </span>
  )
}

export default BioLabel
